import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDatatable } from '../../hooks/useDatatable.js';

import {
    applicant_application_progress_path,
    applicant_project_list_json_path,
} from '~/routes';

function ApplicantProjectListWidget({widgetId, widgetRef, theme}) {
    const tablePlaceholder = useRef();
    const tableRef = useRef();
    const tableContentRef = useRef();
    const initializedRef = useRef(false);
    const sorting = useSelector(state => state.dashboard.widgets[widgetId].settings.sorting);
    const filters = useSelector(state => state.dashboard.widgets[widgetId].settings.filters || []);
    const {pageCount, saveState} = useDatatable({widgetId, tablePlaceholder, tableRef, widgetRef, theme});

    const fixDate = (data) => {
        return data.label;
    };

    const fixId = (data) => {
        return data;
    };

    const fixTitle = (data, type, row, meta) => {
        return '<a target="_blank" title="'+ data.title + '" data-title="'+ data.title + '" href="' + applicant_application_progress_path({project_id: row[0].id}) + '">' + data.title + '</a>';
    };

    const fixRequest = (data) => {
        if (data.order.length === 0) {
            return data;
        }
        data.order[0].column = 2;
        return data;
    };

    const initTable = () => {
        let table;

        const tableEl = tablePlaceholder.current;
        if ($.fn.DataTable.isDataTable(tableEl)) {
            tableEl.DataTable().destroy();
        }

        table = $(tableContentRef.current).DataTable({
            ordering: true,
            serverSide: true,
            ajax: {
                url: applicant_project_list_json_path(),
                data: fixRequest,
            },
            stateSave: true,
            stateSaveParams: saveState,
            info: true,
            searching: false,
            lengthChange: false,
            autoWidth: false,
            pageLength: pageCount,
            pagingType: "simple",
            language: {
                infoFiltered: "", //Hide the fact that the table is filtered
            },
            processing: false,
            sorting: sorting ? sorting[0] : [[2, "desc"]],
            columnDefs: [
                {
                    targets: 0,
                    className: "text-truncate",
                    width: "99%",
                },
                {
                    render: fixDate,
                    targets: 2,
                },
                {
                    render: fixId,
                    targets: 1,
                },
                {
                    render: fixTitle,
                    targets: 0,
                },
            ],
        });

        tableRef.current = table;
    };
    
    useEffect(() => {
        if (!tablePlaceholder.current || initializedRef.current) return;
        initTable();
        initializedRef.current = true;
    }, [tablePlaceholder.current, filters]);

    return (
        <div ref={tablePlaceholder} className="table-content" style={{ width: '100%', height: '100%' }}>
            <table ref={tableContentRef} id={`tasks-${widgetId}`} className="table table-striped table-hover tasks dataTable no-footer task-table nowrap tasks-widget" role="grid" aria-describedby={`tasks-${widgetId}_info`}>
                <thead>
                    <tr role="row">
                    <th data-col="title" style={{ paddingRight: 18 }} tabIndex={0} aria-controls={`tasks-${widgetId}`} aria-label={`${I18n.t('title')}: ${I18n.t('activate_to_sort_column_ascending')}`}>
                        {I18n.t('title')}
                    </th>
                    <th data-col="project_identifier" style={{ paddingRight: 18 }} tabIndex={0} aria-controls={`tasks-${widgetId}`} aria-label={`${I18n.t('project_identifier')}: ${I18n.t('activate_to_sort_column_ascending')}`}>
                        {I18n.t('project_identifier')}
                    </th>
                    <th data-col="last_modified" style={{ paddingRight: 18 }} tabIndex={0} aria-controls={`tasks-${widgetId}`} aria-label={`${I18n.t('last_modified')}: ${I18n.t('activate_to_sort_column_ascending')}`}>
                        {I18n.t('last_modified')}
                    </th>
                    </tr>
                </thead>
                <tbody className="table-body"></tbody>
            </table>
        </div>
    )
};

export default ApplicantProjectListWidget;